import React, { useEffect, useState } from "react";
import DynamicModal from "../../../components/common/DynamicModal";
import TestReport from "./TestReport";

const reportTypes = {
  "7": { title: "Buyer Payment Status Report", linkId: 506 }, 
};

function BuyerPaymentStatus({ open, setOpen, reportType }) {
  const [reportData, setReportData] = useState(null);

  useEffect(() => {
    if (reportType && reportTypes[reportType]) {
      setReportData(reportTypes[reportType]);
    }
  }, [reportType]);

  return (
    <div className="invoice-modal">
      {open && reportData && (
        <DynamicModal
          size="xl"
          title={reportData.title}
          open={open === reportType ? true : false}
          handleClose={() => setOpen("")}
        >
          <TestReport
            title={reportData.title}
            linkId={reportData.linkId}
            reportType={reportType}
          />
        </DynamicModal>
      )}
    </div>
  );
}

export default BuyerPaymentStatus;
